import React from 'react';
import ProgressHeader from './ProgressHeader';
import ContinueButton from './common/ContinueButton';
import { CLASSES } from '../constants/onboardingData';

// Classes groupées par niveau (correspondant à ce qui existe en base)
const CLASS_GROUPS = [
  {
    label: 'Préscolaire',
    classes: ['Préscolaire'],
  },
  {
    label: 'Primaire',
    classes: ['CI', 'CP', 'CE1', 'CE2', 'CM1', 'CM2'],
  },
  {
    label: 'Secondaire',
    classes: ['Collège', 'Lycée'],
  },
];

/**
 * Step 2 (Flow Élève): Classe de l'élève
 */
export default function Step2StudentClass({
  formData,
  currentStepNumber,
  currentStepMessage,
  totalSteps,
  canContinue,
  validationMessage,
  onUpdateStudentInfo,
  onContinue,
  onBack,
}) {
  return (
    <div className="min-h-[100dvh] bg-[#F0FDFA] flex flex-col">
      <ProgressHeader
        currentStep={currentStepNumber}
        totalSteps={totalSteps}
        message={currentStepMessage}
        showBack={true}
        onBack={onBack}
      />

      <div className="flex-1 px-4 pb-4 overflow-y-auto">
        {/* Icône et Titre */}
        <div className="text-center py-6">
          <div className="w-16 h-16 rounded-full bg-[#38BDF8] flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path d="M12 14l9-5-9-5-9 5 9 5z" />
              <path d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                    d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            C'est parti ! 🎉
          </h1>
          <p className="text-gray-500">
            Tu es en quelle classe ?
          </p>
        </div>

        {/* Groupes de classes */}
        <div className="space-y-4">
          {CLASS_GROUPS.map((group) => (
            <div key={group.label} className="bg-white rounded-2xl p-4 shadow-lg">
              <p className="font-semibold text-gray-700 text-center mb-3">{group.label}</p>
              <div className={`grid gap-2 ${group.classes.length <= 2 ? 'grid-cols-2' : 'grid-cols-3'}`}>
                {group.classes.map((classe) => (
                  <div
                    key={classe}
                    onClick={() => onUpdateStudentInfo('studentClass', classe)}
                    className={`
                      py-3 px-2 rounded-xl cursor-pointer transition-all text-center font-medium
                      ${formData.studentClass === classe
                        ? 'bg-[#D1FAE5] text-[#047857] border-2 border-[#10B981]'
                        : 'text-gray-600 hover:bg-gray-50 border border-gray-100'
                      }
                    `}
                  >
                    {classe}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bouton Continuer */}
      <div className="sticky bottom-0 bg-[#F0FDFA] p-4 border-t border-gray-100">
        {validationMessage && !canContinue && (
          <p className="text-center text-sm text-gray-500 mb-2">{validationMessage}</p>
        )}
        <ContinueButton
          onClick={onContinue}
          disabled={!canContinue}
        />
      </div>
    </div>
  );
}
